module.exports = __webpack_public_path__ + "img/amex.25386992.svg";